import React, { useId } from 'react'
import PropTypes from 'prop-types'

const SkipBack2Icon = React.forwardRef(function SkipBack2Icon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 6C8 5.44772 8.44772 5 9 5H12C16.9723 5 21 9.02772 21 14C21 18.9723 16.9723 23 12 23C7.02772 23 3 18.9723 3 14C3 13.4477 3.44772 13 4 13C4.55228 13 5 13.4477 5 14C5 17.8677 8.13228 21 12 21C15.8677 21 19 17.8677 19 14C19 10.1323 15.8677 7 12 7H9C8.44772 7 8 6.55228 8 6Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7071 1.29289C14.0976 1.68342 14.0976 2.31658 13.7071 2.70711L10.4142 6L13.7071 9.29289C14.0976 9.68342 14.0976 10.3166 13.7071 10.7071C13.3166 11.0976 12.6834 11.0976 12.2929 10.7071L7.58578 6L12.2929 1.29289C12.6834 0.902369 13.3166 0.902369 13.7071 1.29289Z"
      ></path>
    </svg>
  )
})

SkipBack2Icon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SkipBack2Icon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default SkipBack2Icon
